import { gpCommon } from '../../app';
import buttonGroupTemplate from './button-group.html';

export interface ButtonGroupOption {
    value: string;
    display: string;
}

export class ButtonGroupComponent {
    options: ButtonGroupOption[] = [];
    model: string | null = null;
    buttonClass: string | null = null;

    constructor() { }

    selectOption(value: string) {
        this.model = value;
    }

    isSelected(value: string) {
        return this.model === value;
    }

    getPositionClasses(index: number) {
        const lastIndex = this.options.length - 1;
        return {
            'gp-k-button-left': index === 0,
            'gp-k-button-middle': index > 0 && index < lastIndex,
            'gp-k-button-right': index === lastIndex
        };
    }
}

gpCommon.component('gpButtonGroup', {
    template: buttonGroupTemplate,
    controller: ButtonGroupComponent,
    bindings: {
        options: '<',
        model: '=',
        buttonClass: '@?'
    }
});
